import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VoucherService } from 'src/app/api/billing/voucher.service';
import { BrandService } from 'src/app/api/catalog/brand.service';
import { GlobalService } from 'src/app/api/global.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import { constants } from 'src/app/constants';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import SwalAlert from 'src/app/utils/swalalert';
import { ToolsService } from 'src/app/utils/tools.service';
import AlertifyHelper from 'src/app/utils/utils';
import * as moment from 'moment';
import { VoucherCancelledExtendsComponent } from '../voucher-cancelled-extends/voucher-cancelled-extends.component';
declare var $: any;

@Component({
  selector: 'app-voucher-list',
  templateUrl: './voucher-list.component.html',
  styleUrls: ['./voucher-list.component.css']
})
export class VoucherListComponent implements OnInit {
  private thisComponent: VoucherListComponent;

  @ViewChild(VoucherCancelledExtendsComponent) VoucherCancelledExtendsComponent: any;

  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  start_range:any = moment().startOf('month');
  end_range:any = moment().endOf('month');

  typevoucher_boleta: any = null;
  typevoucher_factura: any = null;
  typevoucher_income: any = null;
  typevoucher_expense: any = null;
  typevoucher_ordernote: any = null;

  constructor(
    private routeActivated: ActivatedRoute,
    private navigationTrackerService: NavigationTrackerService,
    private voucherService: VoucherService,
    private router: Router,
    private globalService: GlobalService,
    private alert: SwalAlert,
    public toolsService: ToolsService,
    private alertifyMsg: AlertifyHelper,
  ) {
    this.thisComponent = this;
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.typevoucher_boleta = this.toolsService.searchObjByKey(
      'BOLETA_ELECTRONICA',
      constants.SALE.VOUCHER
    );
    this.typevoucher_factura = this.toolsService.searchObjByKey(
      'FACTURA_ELECTRONICA',
      constants.SALE.VOUCHER
    );

    this.typevoucher_income = this.toolsService.searchObjByKey(
      'RECIBO_INGRESO',
      constants.SALE.VOUCHER
    );

    this.typevoucher_expense = this.toolsService.searchObjByKey(
      'RECIBO_EGRESO',
      constants.SALE.VOUCHER
    );
    this.typevoucher_ordernote = this.toolsService.searchObjByKey(
      'NOTA_PEDIDO',
      constants.SALE.VOUCHER
    );
  }

  ngOnInit() {
    this.generateCalendar();
    this.list();
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    (<any>$('[data-toggle="tooltip"]')).tooltip();
  }

  list() {
    let val_params = 'search=' + this.params.search + '&page=' + this.page+
    "&start_range=" + this.start_range.format('YYYY-MM-DD') + '&end_range=' + this.end_range.format('YYYY-MM-DD');
    this.voucherService.list(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;
        console.log(this.items)
        setTimeout(() => {
          this.initPopovers();
        }, 150); 
      }
    });
  }

  initPopovers() {
    // destruye popovers previos para evitar duplicados
    ($('[data-toggle="popover"]') as any).popover('dispose');
    // inicializa
    ($('[data-toggle="popover"]') as any).popover({
      html: true,
      trigger: 'hover click', // ajusta según necesites
      placement: 'right'
    });
  }

  generateCalendar(){
    let component_ = this.thisComponent;
    (<any>$('#date_range')).daterangepicker({
      locale: {
        format: 'YYYY-MM-DD'
      },
      startDate: component_.start_range,
      endDate: component_.end_range,
      showDropdowns: true,
    },
      function(start_date: any, end_date: any) {
        component_.start_range = start_date;
        component_.end_range = end_date;
        component_.list();
      }  
    );
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.start_range = moment().startOf('month');
    this.end_range = moment().endOf('month');
    this.generateCalendar();
    this.list();
  }

  edit(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/catalogo/marcas/editar',
      id
    ]);
    // this.brandService.get(id).subscribe({
    //   next: (data: any) => {
    //     this.router.navigate([ this.branchofficeSlug + '/catalogo/categorias/editar', id]);
    //   }
    // });
  }

  cancelledVoucher(movement: any, _index:any) {
    let options = {
      title: '¡Cuidado!',
      message: "¿Esta seguro(a) de anular y dar de baja el comprobante "+movement.nro_voucher+"?",    
      cancel: 'Cancelar',
      confirm: 'ANULAR COMPROBANTE'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        var data:any = {};
        data.data_cancelled = {
          movement_id:movement.id,
          motive_cancelled:"Error en el detalle de la emisión del comprobante",
          affect_moneybox:false,
        };
        this.voucherService.cancelledVoucher(data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success("El comprobante ha sido dado anulado y dado de baja con éxito");
            this.list();
          }
        });
      }
    });
  }


  sendVoucher(movement:any){
    let options = {
      title: '¡Atención!',
      message: "¿Esta seguro(a) de enviar el comprobante a Sunat?",      
      cancel: 'Cancelar',
      confirm: 'Enviar comprobante'
    };
    this.alert.confirmInfo(options).then((result: any) => {
      if (result.isConfirmed) {
        var data:any = {};
        data.movement = movement;
        this.voucherService.sendVoucher(data).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success("Comprobante enviado con éxito!!");
            this.list();
          }
        });
      }
    });
  }

  downloadXml(item:any){
    let params = "branchoffice_id="+item.branchoffice_id;    
    this.voucherService.getUrlDownloadXml(params).subscribe({
      next: (data: any) => {
        window.open(data.url_download + item.billing_external_id);
      }
    });
  }

  extendsVoucherCancelled(event: any): void {
    this.list();
  }
}
